import { BASE_URL } from "server";

export type Conversation = {
  avatar?: string;
  position: "left" | "right";
  text?: string;
  date: Date;
  image?: string;
  id: string;
  title: string;
  unread?: number;
};

export async function getConversations(type: string): Promise<any> {
  const response = await fetch(
    `${BASE_URL}/conversations/mine?conversationType=${type}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    },
  );

  if (!response.ok) {
    console.log(
      `HTTP error! status: ${response.status}, message : ${response.body}`,
    );
  }

  const fetchedConversations = await response.json();
  const conversations: Conversation[] = [];
  fetchedConversations.forEach((fetchedConversation: any) => {
    const lastBody =
      fetchedConversation?.lastMessage?.body ||
      fetchedConversation?.lastMessage?.content ||
      "";
    const updated =
      fetchedConversation?.updatedAt ||
      fetchedConversation?.lastMessage?.timestamp ||
      fetchedConversation?.lastMessage?.createdAt ||
      new Date().toISOString();

    const conversation: Conversation = {
      position: "left",
      text: lastBody,
      date: new Date(updated),
      avatar: "assets/img/logoJaune.png",
      id: fetchedConversation._id,
      title: fetchedConversation.title,
      unread: fetchedConversation.unreadMessagesCount || 0,
    };
    conversations.push(conversation);
  });

  conversations.sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
  return conversations;
}
